import axios, {AxiosResponse} from 'axios';
import {
    EMPLOYMENT_BATCH_ENDPOINT, EMPLOYMENT_ENDPOINT
} from '@/constants/endpoints'
import authHeader from "@/services/auth-header";
import QueryUtils from "@/utils/QueryUtils";
import EmploymentDTO from "@/dto/employee/EmploymentDTO";
import CreateEmploymentRequestDTO from "@/dto/employee/CreateEmployeeRequestDTO";
import Workspaces from "@/state/Workspaces";
import { IEmployment } from "@/dto/payroll/IEmployment";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import Pageable from "@/dto/Pageable";
class EmploymentService {

    batchUpload(fileId: number){
        return axios.post(`${EMPLOYMENT_BATCH_ENDPOINT}/${fileId}`,{},{headers: authHeader()});
    }

    createEmployment(employee: CreateEmploymentRequestDTO){
        return axios.post<EmploymentDTO>(EMPLOYMENT_ENDPOINT, employee, {headers: authHeader()});
    }

    getPageByFilter<T extends IEmployment>(filter: EmploymentFilter): Promise<AxiosResponse<Pageable<T>>> {
        const queryString = QueryUtils.objectToQueryString(filter)
        return axios.get<Pageable<T>>(`${EMPLOYMENT_ENDPOINT}/page${queryString}`, {headers: authHeader()});
    }

    getAllByFilter<T extends IEmployment>(filter: EmploymentFilter): Promise<AxiosResponse<Array<T>>> {
        const queryString = QueryUtils.objectToQueryString(filter)
        return axios.get<Array<T>>(`${EMPLOYMENT_ENDPOINT}${queryString}`, {headers: authHeader()})
    }

    public getById<T extends IEmployment | null>(employmentId: number | string) {
        return axios.get<T>(`${EMPLOYMENT_ENDPOINT}/${employmentId}`, {headers: authHeader()});
    }

    getAllEmploymentsByDetailsId(detailsId: number = Workspaces.getCurrent.id) {
        return axios.get<Array<IEmployment>>(`${EMPLOYMENT_ENDPOINT}/details/${detailsId}`, {headers: authHeader()})
    }

}

export default new EmploymentService();
